import Dropcursor from '@tiptap/extension-dropcursor';

export default Dropcursor.configure();
